module.exports = __webpack_public_path__ + "img/9.da1a3b27.png";